import React from 'react';
const Reports = () => {
    return (
        <div className="flex items-center justify-center h-screen bg-gray-100">
          <div className="text-center">
            <h1 className="text-6xl font-bold text-gray-800">404</h1>
            <p className="text-2xl text-gray-600 mt-4">Oops! Page not found.</p>
            <p className="text-gray-500 mt-2">The page you are looking for does not exist.</p>
            <button
              className="mt-6 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              onClick={() => window.location.href = '/dashboard'}
            >
              Go to Home
            </button>
          </div>
        </div>
      );
    };

export default Reports





  